"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var mobx_1 = require("mobx");
var convert_case_keys_1 = require("@hikakaku/shared/util/convert_case_keys");
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var constants_1 = require("@hikakaku/shared/constants");
var SHOW_COMPLETE_DIALOG_DURATION = 3000;
var ReservationDateStore = /** @class */ (function () {
    function ReservationDateStore(_a) {
        var postReservationUrl = _a.postReservationUrl;
        var _this = this;
        this.reservationDates = [];
        this.setDate = function (index, date) {
            if (index < _this.reservationDates.length) {
                _this.reservationDates[index] = date;
            }
            else if (index < constants_1.RESERVATION.MAX_DATE_SIZE) {
                _this.reservationDates.push(date);
            }
        };
        this.postData = function () {
            var reservationDatesAttributes = _this.reservationDates.reduce(function (body, value, idx) { body[String(idx)] = value; return body; }, {});
            var data = (0, convert_case_keys_1.toSnakeKeys)({ reservationDates: { reservationDatesAttributes: reservationDatesAttributes } });
            return axios_1.default
                .post(_this.postReservationUrl, data)
                .then(function () {
                dialog_store_1.default.showDialog({
                    title: '本査定予約日を送信しました',
                    description: '',
                    show_time: SHOW_COMPLETE_DIALOG_DURATION
                });
                setTimeout(function () { return window.location.reload(); }, SHOW_COMPLETE_DIALOG_DURATION);
            })
                .catch(function (_a) {
                var response = _a.response;
                var data = response === null || response === void 0 ? void 0 : response.data;
                if (data && data.version === 'v1') {
                    dialog_store_1.default.showErrorDialog(data.message, data.details);
                }
                else {
                    dialog_store_1.default.showErrorDialog();
                }
            });
        };
        this.postReservationUrl = postReservationUrl;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ReservationDateStore.prototype, "reservationDates", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ReservationDateStore.prototype, "setDate", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ReservationDateStore.prototype, "postData", void 0);
    return ReservationDateStore;
}());
exports.default = ReservationDateStore;
